import type { NxStatusMap } from '@soft2code/nexpo-lib/ui';

/**
 * As situações que o console vê: do chamado, da feira, do pedido de feira e
 * do comunicado. O chamado segue quem precisa agir; o pedido, a conversa
 * comercial.
 */
export const OWNER_STATUS_MAP: NxStatusMap = {
	OPEN: { label: { 'pt-BR': 'Novo', es: 'Nuevo', en: 'New' }, tone: 'info' },
	PROGRESS: { label: { 'pt-BR': 'Em andamento', es: 'En curso', en: 'In progress' }, tone: 'warning' },
	RESOLVED: { label: { 'pt-BR': 'Resolvido', es: 'Resuelto', en: 'Resolved' }, tone: 'success' },
	CLOSED: { label: { 'pt-BR': 'Fechado', es: 'Cerrado', en: 'Closed' }, tone: 'neutral' },

	DRAFT: { label: { 'pt-BR': 'Rascunho', es: 'Borrador', en: 'Draft' }, tone: 'neutral' },
	PUBLISHED: { label: { 'pt-BR': 'Publicada', es: 'Publicada', en: 'Published' }, tone: 'success' },
	CANCELLED: { label: { 'pt-BR': 'Cancelada', es: 'Cancelada', en: 'Cancelled' }, tone: 'danger' },
	FINISHED: { label: { 'pt-BR': 'Encerrada', es: 'Finalizada', en: 'Finished' }, tone: 'neutral' },

	NEW: { label: { 'pt-BR': 'Novo', es: 'Nuevo', en: 'New' }, tone: 'info' },
	CONTACTED: { label: { 'pt-BR': 'Em conversa', es: 'En conversación', en: 'Talking' }, tone: 'accent' },
	PROPOSAL_SENT: {
		label: { 'pt-BR': 'Proposta enviada', es: 'Propuesta enviada', en: 'Proposal sent' },
		tone: 'warning',
	},
	WON: { label: { 'pt-BR': 'Fechado', es: 'Cerrado', en: 'Won' }, tone: 'success' },
	LOST: { label: { 'pt-BR': 'Perdido', es: 'Perdido', en: 'Lost' }, tone: 'neutral' },

	SCHEDULED: { label: { 'pt-BR': 'Agendado', es: 'Programado', en: 'Scheduled' }, tone: 'info' },
	EXPIRED: { label: { 'pt-BR': 'Expirado', es: 'Vencido', en: 'Expired' }, tone: 'neutral' },
	ARCHIVED: { label: { 'pt-BR': 'Arquivado', es: 'Archivado', en: 'Archived' }, tone: 'neutral' },
};
